import React from 'react';

const Page = ({ title, lead, infoPanel, header, footer, children }) => {
  return (
    <div>
      <div className="jumbotron jumbotron-fluid hero-header pb-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="hero-header__container">
                <div className="hero-header__headline">
                  <h1>{title}</h1>
                  <p className="lead">{lead}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 order-2 order-lg-1 mb-3">{infoPanel}</div>
          <div className="col-lg-6 order-1 order-lg-2">
            <div className="card action-card border shadow mb-3">
              <div className="card-header">{header}</div>
              <div className="card-body">{children}</div>
              {footer}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page;
